<ng-container *ngIf="!this._UserHelper?.isSignedIn">
  <login-base-component></login-base-component>
</ng-container>
<div class="login-mobile text" *ngIf="this._UserHelper?.isSignedIn">
  <div class="sidenav-header">
    <div class="left">{{ this._UserHelper?.customerUser.UserName }}</div>
    <div class="right" (click)="closeSideBar()">
      <image-loader-utils url="close" extraClasses="close-icon"></image-loader-utils>
    </div>
  </div>
  <div class="user-up-container" *ngIf="false">
    <ng-container *ngIf="this._UserHelper.walletList && this._UserHelper.walletList.length > 0">
      <div class="wallet-card-container" *ngFor="let item of this._UserHelper.walletList; let i = index">
        <div
          class="shop-card gray-wallet-card"
          [ngClass]="{
            borderB: !(this._UserHelper.walletList.length - 1 === i) || !(this._UserHelper.walletList.length === 1 && i === 0),
            'disabled-row': !item.IsActive,
            active: item.CustomerId == this._UserHelper.customerUser?.CustomerId
          }"
          (click)="walletSelectChange(item)">
          <div class="shop-card-header no-border-bottom">
            <div class="left-box">
              <div class="shop-icon">
                <image-loader-utils
                  [url]=""
                  [extraClasses]="
                    item.BranchType === 1
                      ? 'sportmenusvg wallet-svg shop-wallets'
                      : item.BranchType === 3
                      ? 'sportmenusvg wallet-svg shop-wallets'
                      : item.BranchType === 0
                      ? 'sportmenusvg wallet-svg shop-wallets'
                      : 'sportmenusvg wallet-svg'
                  "></image-loader-utils>
              </div>
              {{ item.BranchType == 1 ? ('online_sports' | translate) : item.BrancName }}
            </div>
            <div class="shop-balance">
              <span>
                {{ item.Balance | balanceFormat }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <div class="shop-container deposit-btn green-deposit-btn" (click)="OpenAccountMobile('account/credit')">{{ 'Deposit' | translate }}</div>
  </div>
  <div class="mid-container">
    <div class="mid-container-row" (click)="OpenAccountMobile('/account/bet-slip')">
      <div class="left-svg">
        <image-loader-utils url="file" extraClasses="svg-file-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'betting_history' | translate }}</div>
      <div class="right"></div>
    </div>

    <div class="mid-container-row" (click)="userDropdownOpen()">
      <div class="left-svg">
        <image-loader-utils url="account" extraClasses="svg-account-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'MyAccount' | translate }}</div>
      <div class="right">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (userDropdownIsOpen ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <div class="drop-down-mobile-menu" [ngClass]="{ displayShow: userDropdownIsOpen }">
      <account-menu-component menuSelect="rightMenu" [userHelper]="this._UserHelper" [UiHelper]="this._UiHelper"></account-menu-component>
    </div>

    <div class="mid-container-row" (click)="SignOutDialogOpener(true)">
      <div class="left-svg">
        <image-loader-utils url="logout" extraClasses="svg-logout-icon"></image-loader-utils>
      </div>
      <div class="mid">{{ 'right_menu_sign_out' | translate }}</div>
      <div class="right"></div>
    </div>
    <div class="mid-container-row">
      <div class="left">{{ 'last_login' | translate }}</div>
      <div class="mid last-login-date">
        {{ this._UserHelper?.customerUser.LastLoginDate | dateFormat : 'dd-MM-yyyy hh:mm a' }}
      </div>
    </div>
  </div>
</div>
<div *ngIf="environment.isPromotion" class="promotion-button" routerLink="/promotions">
  <div class="promotion-button-text-container">
    <image-loader-utils url="promotion" extraClasses="promotion-icon"></image-loader-utils>
    <div class="promotion-button-text">
      {{ 'PROMOTIONS' | translate }}
    </div>
  </div>
  <div class="promotion-button-count-container">
    <div class="promotion-button-count">
      {{ this._PromotionService.promotionCount }}
    </div>
    <image-loader-utils url="up-arrow" extraClasses="arrow-icon right"></image-loader-utils>
  </div>
</div>
<div class="switch-container" [ngClass]="{ 'sign-in': this._UserHelper?.isSignedIn }">
  <ng-container *ngIf="'isDarkMode' | getEnv">
    <div class="switch-row">
      <div class="switch-text">{{ 'dark_mode' | translate }}</div>
      <div class="switch-select">
        <mat-slide-toggle color="primary" (click)="changeTheme()" checked="{{ this._UiHelper.currentTheme === 'theme-dark' }}"></mat-slide-toggle>
      </div>
    </div>
  </ng-container>

  <div class="switch-row">
    <div class="switch-text">{{ 'quick_bet' | translate }}</div>
    <div class="switch-select">
      <mat-slide-toggle color="primary" (click)="changeQuickTipp()" checked="{{ quickTippChecked }}"></mat-slide-toggle>
    </div>
  </div>

  <div *ngIf="'isOddFormatTypeSelect' | getEnv" class="language-menu">
    <div class="selected-language" (click)="toggleOddFormatMenu()">
      <div class="selected-odd-format-name">
        {{ this._UiHelper.customerSelectedOddFormatObject[0]?.name }}
      </div>
      <div class="right">
        <image-loader-utils url="up-arrow" [extraClasses]="'arrow-icon ' + (isOpenLangMenu ? 'up' : 'down')"></image-loader-utils>
      </div>
    </div>
    <ng-container *ngFor="let format of this._UiHelper.oddsFormatTypeData">
      <div class="lang-dropdown-menu" *ngIf="isOpenOddFormatMenu">
        <div class="lang-dropdown-item" (click)="selectFormatType(format.id)">
          <label for="odd_format_{{ format.id }}" class="odd_format_row">
            <div class="odd_format_row">
              {{ format.name }}
            </div>
          </label>
        </div>
      </div>
    </ng-container>
  </div>

  <language-dropdown-component></language-dropdown-component>
</div>
